import { inject, observer } from 'mobx-react';
import * as React from 'react';
import LanguageStore from '@stores/LanguageStore';
import { ThemeProvider } from 'telia-front-react';

interface Props {
  children?: React.ReactChild | React.ReactChild[];
  languageStore?: LanguageStore;
}

export const getIconPath = (name: string) => {
  const req = require.context('@telia-front/icon/lib/svg/', false, /^\.\/icons.svg$/);
  return req(req.keys()[0]) + name;
};

const TeliaThemeProvider: React.FC<Props> = inject('languageStore')(
  observer((props: Props): React.ReactElement => {
    return (
      <ThemeProvider locale={props.languageStore.currentLocale} getIconPath={getIconPath}>
        {props.children}
      </ThemeProvider>
    );
  })
);
export default TeliaThemeProvider;
